import * as $ from 'jquery';
import { Directive, Inject, SkipSelf, HostListener } from 'ng-metadata/core';

/**
 * Dropdown Toggle
 *
 * Simple attribute directive to toggle state
 * of dropdown on parent controller. Uses events.
 */
@Directive({
  selector: '[gwDropToggle]',
})
export class DropToggleDirective {

  constructor(
    @Inject('gwDrop') @SkipSelf() private drop,
    @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
  ) {}

  @HostListener('click')
  clickOnHostElement() {
    this.$rootScope.$broadcast('gw-close-drop');
    this.drop.isOpen = !this.drop.isOpen;
    if (this.drop.isOpen) {
      this.$rootScope.$broadcast('gw-drop-opened');
    }
  }

  @HostListener('focus')
  onFocus() {
    this.$rootScope.$broadcast('gw-close-drop');
  }

  @HostListener('keydown', ['$event'])
  onKeypress($event) {
    if ($event.keyCode && $event.keyCode === 40) {
      $event.preventDefault();
      this.drop.isOpen = true;
      this.$rootScope.$broadcast('gw-drop-opened');
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/drop/drop-toggle.directive.ts